import { prefix } from "../../design-tokens/meta";
import { actions, events } from "../../js/state-machine";

export const componentName = "SideNav";

export const sideNavClasses = {
    fixed: `${prefix}side-nav__wrapper--fixed`,
    toggleButton: `.${prefix}side-nav__toggle > button`,
    group: `${prefix}side-nav__group`,
    itemSelected: `${prefix}side-nav__item--selected`,
    groupSelected: `${prefix}side-nav__group--selected`,
};

export const initialState = {
    expand: true,
};

export const defaultProps = {
    expand: true,
    fixed: false,
};

export const validProps = {
    expand: [true, false],
    fixed: [true, false],
};

export const views = {
    expanded: {
        attrs: { "aria-expanded": "true" },
    },
    collapsed: {
        attrs: { "aria-expanded": "false" },
    },
    fixed: {
        attrs: { "aria-expanded": "true" },
        classList: [sideNavClasses.fixed],
    },
    collapsible: {
        classList: [`!${sideNavClasses.fixed}`],
    },
};

// Actions mapped into event values to be used as callback for the actions.
export const eventMap = {
    [actions.expand().type]: events.expanded(componentName),
    [actions.collapse().type]: events.collapsed(componentName),
};
